import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Faq, FaqSection } from '../../../../classes/http-responses';
import { GeneralQuestionsComponent } from '../general-questions.component';
import { AppSettings } from '../../../../app.settings';

@Component({
	selector: 'general-questions-item',
	template: require('./general-questions-item.component.html'),
})
export class GeneralQuestionsItemComponent implements OnInit {
	@Input() faq: Faq;
	@Input() faqSection: FaqSection;
	public sanitizedHtml: string;
	public isRebrading = AppSettings.isRebrading;
	constructor(
		private modalService: NgbModal,
		private activeModalService: NgbActiveModal,
		private sanitizer: DomSanitizer
	) {}

	ngOnInit(): void {
		this.sanitizedHtml = this.sanitizer.sanitize(SecurityContext.HTML, this.faq.answer);
	}

	closeModal() {
		this.activeModalService.close();
	}

	back() {
		this.activeModalService.close();
		let modalRef = this.modalService.open(GeneralQuestionsComponent);
		modalRef.componentInstance.section = this.faqSection;
	}
}
